import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CartaoCredito from './telas/cadastros/cartaoCredito/CartaoCredito';
import Categoria from './telas/cadastros/categoria/Categoria';
import Dashboard from './telas/dashboard/Dashboard';
import Conta from './telas/cadastros/conta/Conta';
import Movimentacoes from './telas/movimentacoes/Movimentacoes';
import { ContaContexto } from './contextos/ContaContexto';
import { useEffect, useState } from 'react';
import { Conta as TipoConta } from './servicos/contas/typeConta';
import { CategoriaContexto } from './contextos/CategoriaContexto';
import { Categoria as TipoCategoria } from './servicos/categorias/typeCategoria';
import { TransacaoContexto } from './contextos/TransacaoContexto';
import { Transacao as TipoTransacao } from './servicos/transacoes/typeTransacao';
import { PerfilContexto } from './contextos/PerfilContexto';
import { Perfil as TipoPerfil } from './servicos/perfis/typePerfil';
import { AvisoContexto, AvisoType } from './contextos/AvisoContexto';
import { CartaoCredito as TipoCartao } from './servicos/cartaoCredito/typeCartaoCredito';
import { CartaoCreditoContexto } from './contextos/CartaoCreditoContexto';
import { Filtro as TipoFiltro } from './servicos/filtro/typeFiltro';
import Landing from './telas/landing/Landing';
import Termos from './telas/landing/termos/Termos';
import { AtualizacaoContexto } from './contextos/AtualizacaoContexto';
import { FiltroContexto } from './contextos/FiltroContexto';
import Avisos from './telas/estruturais/aviso/Avisos';
import { AuthProvider } from './contextos/AuthContext';
import RotaProtegida from './componentes/rotaProtegida/RotaProtegida';
import DefinirSenha from './telas/login/definirSenha/DefinirSenha';
import Login from './telas/login/Login';
import CriarConta from './telas/login/criarConta/CriarConta';
import RecuperarSenha from './telas/login/recuperarSenha/RecuperarSenha';
import Metas from './telas/metas/Metas';
import Configuracoes from './telas/configuracoes/Configuracoes';
import Importar from './telas/importar/Importar';

const filtroFinal = new Date(); // Hoje
const filtroInicial = new Date();
filtroInicial.setMonth(filtroFinal.getMonth() - 1);

export default function Rotas() {
  const [contas, setContas] = useState<TipoConta[]>([]);
  const [categorias, setCategorias] = useState<TipoCategoria[]>([]);
  const [transacoes, setTransacoes] = useState<TipoTransacao[]>([]);
  const [perfil, setPerfil] = useState<TipoPerfil>({});
  const [avisos, setAvisos] = useState<AvisoType[]>([]);
  const [cartoes, setCartoes] = useState<TipoCartao[]>([]);
  const [filtros, setFiltros] = useState<TipoFiltro>({
    dashboard: { dataInicial: filtroInicial, dataFinal: filtroFinal },
    movimentacao: { dataInicial: filtroInicial, dataFinal: filtroFinal }
  });
  const [atualizar, setAtualizar] = useState<boolean>(false);

  useEffect(() => {
    const root = document.documentElement;
    const tema = localStorage.getItem('tema');
    const cor = localStorage.getItem('cor');
    root.setAttribute('data-theme', tema || 'light');
    root.style.setProperty('--primary', cor || '#6366f1');
    root.style.setProperty('--secondary', cor ? cor + '10' : '#6366f110');
  }, []);

  return (
    <BrowserRouter>
      <AtualizacaoContexto.Provider value={{ atualizar, setAtualizar }}>
        <PerfilContexto.Provider value={{ perfil, setPerfil }}>
          <ContaContexto.Provider value={{ contas, setContas }}>
            <CategoriaContexto.Provider value={{ categorias, setCategorias }}>
              <TransacaoContexto.Provider value={{ transacoes, setTransacoes }}>
                <AvisoContexto.Provider value={{ avisos, setAvisos }}>
                  <CartaoCreditoContexto.Provider value={{ cartoes, setCartoes }}>
                    <FiltroContexto.Provider value={{ filtros, setFiltros }}>
                      <AuthProvider>
                        <Avisos>
                          <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/termos-e-politicas" element={<Termos />} />
                            <Route path="/entrar" element={<Login />} />
                            <Route path="/criar-conta" element={<CriarConta />} />
                            <Route path="/recuperar-senha" element={<RecuperarSenha />} />
                            <Route path="/definir-senha" element={<DefinirSenha />} />
                            <Route path="/dashboard" element={<RotaProtegida><Dashboard /></RotaProtegida>} />
                            <Route path="/movimentacoes" element={<RotaProtegida><Movimentacoes /></RotaProtegida>} />
                            <Route path="/contas" element={<RotaProtegida><Conta /></RotaProtegida>} />
                            <Route path="/cartoes" element={<RotaProtegida><CartaoCredito /></RotaProtegida>} />
                            <Route path="/categorias" element={<RotaProtegida><Categoria /></RotaProtegida>} />
                            <Route path="/metas" element={<RotaProtegida><Metas /></RotaProtegida>} />
                            <Route path="/importar" element={<RotaProtegida><Importar /></RotaProtegida>} />
                            <Route path="/configuracoes" element={<RotaProtegida><Configuracoes /></RotaProtegida>} />
                          </Routes>
                        </Avisos>
                      </AuthProvider>
                    </FiltroContexto.Provider>
                  </CartaoCreditoContexto.Provider>
                </AvisoContexto.Provider>
              </TransacaoContexto.Provider>
            </CategoriaContexto.Provider>
          </ContaContexto.Provider>
        </PerfilContexto.Provider>
      </AtualizacaoContexto.Provider>
    </BrowserRouter>
  );
}

